import { API_URL } from "@env"

export function makeResourceUrl(path: string): string {
  console.log("")
  return API_URL + "/" + path
}
